import Paths from "routes/Paths";

/** Query parameter carrying the in-app path to return to after signing in. */
export const SIGN_IN_REDIRECT_PARAM = "redirect";

/** Builds the sign-in path with the given in-app path preserved as the post-sign-in destination. */
export const getSignInPathWithRedirect = (target: string): string =>
	`${Paths.signIn}?${SIGN_IN_REDIRECT_PARAM}=${encodeURIComponent(target)}`;

/** Builds the sign-up path with the given in-app path preserved as the post-registration destination. */
export const getSignUpPathWithRedirect = (target: string): string =>
	`${Paths.signUp}?${SIGN_IN_REDIRECT_PARAM}=${encodeURIComponent(target)}`;

/**
 * Reads the post-sign-in destination from a query string. Only same-app absolute paths are
 * honoured ("//host" and full URLs are rejected) so the parameter cannot become an open redirect.
 */
export const getPostSignInPath = (search: string): string => {
	const target = new URLSearchParams(search).get(SIGN_IN_REDIRECT_PARAM);

	return target?.startsWith("/") && !target.startsWith("//") ? target : Paths.root;
};
